
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import BookCard from './BookCard.vue'
import PageContainer from '~/components/Containers/PageContainer.vue'
import { ContainerOptions } from '~/model'
import SwiperContainer from '~/components/Containers/SwiperContainer.vue'

@Component({
  components: {
    BookCard,
    PageContainer,
    SwiperContainer
  }
})
export default class extends Vue {
  @Prop({
    default: () => {}
  })
  readonly containerOptions!: ContainerOptions

  @Prop({
    default: () => [
      {
        id: 'book0',
        author: 'Д. А. Рощин',
        name: 'Способы применения компьютерного зрения для повышения точности проведения аэрофотогрфичекской съёмки местности',
        image: '/images/book-example.jpg'
      },
      {
        id: 'book1',
        author: 'Д. А. Рощин',
        name: 'Способы применения компьютерного зрения для повышения точности проведения аэрофотогрфичекской съёмки местности',
        image: '/images/book-example.jpg'
      },
      {
        id: 'book2',
        author: 'Д. А. Рощин',
        name: 'Способы применения компьютерного зрения для повышения точности проведения аэрофотогрфичекской съёмки местности',
        image: '/images/book-example.jpg'
      },
      {
        id: 'book3',
        author: 'Д. А. Рощин',
        name: 'Способы применения компьютерного зрения для повышения точности проведения аэрофотогрфичекской съёмки местности',
        image: '/images/book-example.jpg'
      },
      {
        id: 'book4',
        author: 'Д. А. Рощин',
        name: 'Способы применения компьютерного зрения для повышения точности проведения аэрофотогрфичекской съёмки местности',
        image: '/images/book-example.jpg'
      },
      {
        id: 'book5',
        author: 'Д. А. Рощин',
        name: 'Способы применения компьютерного зрения для повышения точности проведения аэрофотогрфичекской съёмки местности',
        image: '/images/book-example.jpg'
      },
      {
        id: 'book6',
        author: 'Д. А. Рощин',
        name: 'Способы применения компьютерного зрения для повышения точности проведения аэрофотогрфичекской съёмки местности',
        image: '/images/book-example.jpg'
      }
    ]
  })
  readonly bookCards!: []

  desktopSliderOptions = {}
  tabletSliderOptions = {
    loop: false,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 10
  }

  mobileSliderOptions = {
    loop: false,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 10
  }

  mounted() {
    const id = Math.floor(Math.random() * 16777215).toString(16)
    this.desktopSliderOptions = {
      loop: false,
      slidesPerView: 6,
      slidesPerGroup: 1,
      spaceBetween: 10,
      navigationId: id
    }
  }

  clickCard(slug: string) {
    this.$emit('on-click-book-card', slug)
  }
}
